import { makeAutoObservable } from 'mobx';

import { PlayerActionState } from './state/PlayerActionState';
import { StateStore } from './StateStore';

class PlayerActionStore implements StateStore {
  public playerActions: PlayerActionState[] = [];

  public playerActionStateChanged = 0;

  public constructor() {
    makeAutoObservable(this);
  }

  public resetState = (): void => {
    this.playerActions = [];
    this.playerActionStateChanged = 0;
  };

  public addPlayerAction = (playerAction: PlayerActionState): void => {
    this.playerActions.push(playerAction);
    this.changePlayerActionState();
  };

  public getPlayerAction = (
    tableId: string,
    pid: string,
  ): PlayerActionState | undefined =>
    this.playerActions
      .filter(action => action.pid === pid && action.tableId === tableId)
      .pop();

  public clear = (tableId: string, pid: string): void => {
    const indexToRemove = this.playerActions.findIndex(
      action => action.pid === pid && action.tableId === tableId,
    );
    if (indexToRemove > -1) {
      this.playerActions.splice(indexToRemove, 1);
    }
  };

  public clearAllPlayerActions = (): void => {
    this.playerActions = [];
  };

  public changePlayerActionState = (): void => {
    this.playerActionStateChanged++;
  };
}

const playerActionStore = new PlayerActionStore();
export default playerActionStore;
